
import {Grid, Typography} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {Link, useParams} from "react-router-dom";
import Blog_Home from "./Componentes/Blog_Home";
import {servicios} from "../../data/servicios.js";


const Seccion_Servicio_Detalle = () => {

    const {id} = useParams();
    const servicio = servicios.find((p) => p.id === id);

    if (!servicio) {
        return <Typography variant="h6">Post no encontrado</Typography>;
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{maxWidth: 1400, px: 3, pt: 16}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <ArrowBackIosNewIcon sx={{color: "primary.main", fontSize: 20, mr: 1}}/>
                    <Typography
                        component={Link}
                        to="/"
                        sx={{
                            textDecoration: "none",
                            color: "primary.main",
                            fontWeight: "bold",
                            "&:hover": {textDecoration: "underline"},
                        }}
                    >
                        Volver al inicio
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:8}}>
                    <Typography variant="body1">
                        {servicio.fechaPublicacion}
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                    <Typography variant="h1" >
                        {servicio.titulo}
                    </Typography>
                </Grid>


                <Grid
                    container
                    size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                    <Typography variant="body1">
                        {servicio.descripcion}
                    </Typography>
                </Grid>


                <Grid container spacing={4} size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                    {servicio.contenido.map((section, index) => (
                        <section key={index}>
                            <Typography variant='h2' >{section.subtitulo}</Typography>
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:2}}>
                                {section.parrafos.map((texto, i) => (
                                    <Typography variant='body1' key={i}>{texto}</Typography>
                                ))}
                            </Grid>

                        </section>
                    ))}
                </Grid>



            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:8}}>
                <Blog_Home/>
            </Grid>
        </Grid>
    )

}
export default Seccion_Servicio_Detalle